import { render, staticRenderFns } from "./MdcButton.vue?vue&type=template&id=47d9fefe&scoped=true"
import script from "./MdcButton.vue?vue&type=script&lang=js"
export * from "./MdcButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d9fefe",
  null
  
)

export default component.exports